import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { asyncRequest, Entities, TOMCAT_URL } from 'src/common';
import autoBind from 'react-autobind';
import BusYieldLocationMap from 'src/components/admin/bus-yield-locations-stats/bus-yield-location-map';
import _ from 'lodash';
import BusYieldTable from 'src/components/admin/bus-yield-locations-stats/bus-yield-table';
import BusYieldLegend from 'src/components/admin/bus-yield-locations-stats/bus-yield-legend';
import CircularProgress from 'material-ui/CircularProgress';

class BusYieldStatistics extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            // requested backend data
            companies: {
                entities: [],
                isFetching: true,
                error: undefined,
            },
            filteredCompanies: {
                entities: [],
                isFetching: true,
                error: undefined,
            },
            groupedCompanies: [],
            // containing selected companies with buses
            busYieldStatistics: [],
            operatorCountries: [],
            selectedCountryFilter: 'All',
            showUnavailableBuses: false,

            // count of all unique bus and company locations
            busLocationCount: undefined,
            companyLocationCount: undefined,

            // the company you individually selected
            companySelected: null,
        };
    }

    componentDidMount() {
        this.loadCompaniesWithBuses();
    }

    getUniqueLocationsForCompanies(companiesWithBuses) {
        const companiesByLocation = [];

        companiesWithBuses.forEach(busYieldDetails => {
            const company = busYieldDetails.company;
            const indexOfCompanyWithSameLocation = companiesByLocation.findIndex(entity =>
                _.isEqual(entity.location, company.location),
            );

            // add company to an already existing location
            if (indexOfCompanyWithSameLocation !== -1) {
                companiesByLocation[indexOfCompanyWithSameLocation].companies.push({
                    id: company.id,
                    companyName: company.companyName,
                    availableBuses: busYieldDetails.availableBuses,
                    totalBuses: busYieldDetails.totalBuses,
                    logo: company.logo,
                });
            }

            // add new location
            else {
                companiesByLocation.push({
                    location: company.location,
                    companies: [
                        {
                            id: company.id,
                            companyName: company.companyName,
                            logo: company.logo,
                            availableBuses: busYieldDetails.availableBuses,
                            totalBuses: busYieldDetails.totalBuses,
                        },
                    ],
                });
            }
        });

        return companiesByLocation;
    }

    onCountryChange(event) {
        const selectedCountry = event.target.value;

        this.setState({ selectedCountryFilter: selectedCountry }, () => {
            // This callback runs AFTER state is updated
            this.filterBuses();
        });
    }

    onUnavailableBusesToggle(e, val) {
        this.setState({ showUnavailableBuses: val }, () => {
            this.filterBuses();
        });
    }

    filterBuses() {
        const { companies, selectedCountryFilter, showUnavailableBuses } = this.state;
        const allCompanies = companies.entities;

        const filteredCompanies = allCompanies.filter(item => {
            const matchesCountry =
                selectedCountryFilter === 'All' || item.company.contactData.country === selectedCountryFilter;

            const matchesAvailability = showUnavailableBuses || item.availableBuses > 0;

            return matchesCountry && matchesAvailability;
        });
        this.setState({
            filteredCompanies: {
                entities: filteredCompanies,
                isFetching: false,
                error: undefined,
            },
        });
    }

    render() {
        const { t } = this.props;
        const { filteredCompanies, companies } = this.state;

        if (companies.isFetching) return <CircularProgress />;
        return (
            <>
                <div>
                    <div className="col-md-12">
                        <BusYieldLegend
                            t={t}
                            detailedOperatorInformation={filteredCompanies.entities}
                            onCountryChange={this.onCountryChange}
                            operatorCountries={this.state.operatorCountries}
                            showUnavailableBuses={this.state.showUnavailableBuses}
                            onUnavailableBusesToggle={this.onUnavailableBusesToggle}
                        />
                    </div>
                    <div className="col-md-12">
                        <BusYieldLocationMap
                            companies={filteredCompanies.entities}
                            t={t}
                            showCompanies={true}></BusYieldLocationMap>
                    </div>
                    <div className="col-md-12">
                        <BusYieldTable companies={filteredCompanies.entities} i18n={this.props.i18n} t={this.props.t} />
                    </div>
                </div>
            </>
        );
    }

    loadCompaniesWithBuses() {
        asyncRequest({
            method: 'GET',
            endpoint: `${TOMCAT_URL}api/${Entities.BUS_YIELD_STAT.repository}/get-real-yield`,
        })
            .then(response => {
                this.setState({
                    companies: {
                        entities: response.json.detailedOperatorInformation,
                        isFetching: false,
                        error: undefined,
                    },
                    filteredCompanies: {
                        entities: response.json.detailedOperatorInformation.filter(item => item.availableBuses > 0),
                        isFetching: false,
                        error: undefined,
                    },
                    groupedCompanies: this.getUniqueLocationsForCompanies(response.json.detailedOperatorInformation),
                    busYieldStatistics: response.json,

                    operatorCountries: [
                        ...new Set(
                            response.json.detailedOperatorInformation.map(item => item.company.contactData.country),
                        ),
                    ],
                });
            })
            .catch(error =>
                this.setState({
                    companies: {
                        entities: [],
                        isFetching: false,
                        error: error.status,
                    },
                    filteredCompanies: {
                        entities: [],
                        isFetching: false,
                        error: error.status,
                    },
                }),
            );
    }
}

export default withTranslation()(BusYieldStatistics);
